<script setup>
    const { $builder, $bus } = useNuxtApp();

    const props = defineProps({
        name: {
            type: String,
            default: '',
        }
    });

    const open = defineModel('open');
    const { data, pending, error, status } = await $builder.get('help-modals', { query: { name: props.name } }, `help-modal-${props.name}`);

    const sections = computed(() => {
        if (!data.value?.data?.sections) return [];
        return data.value.data.sections.map((section) => ({
            label: section.title,
            content: section.copy,
        }));
    });

    watch(open, (val) => {
        if (val) $bus.emit('drawer-open');
        else $bus.emit('drawer-close');
    });

    const drawerStyles = {
        overlay: 'bg-[var(--purple)]/80 backdrop-blur-xs',
    };
</script>

<template>
    <UDrawer v-model:open="open" id="help-drawer" direction="right" :dismissable="true" :title="`${props.name} Help`" :handle="false" :handleOnly="true" :ui="drawerStyles" class="help-drawer w-[60svw] max-w-217 text-(--teal)">
        <template #header>
            <div class="header flex justify-between items-center">
                <div class="headline" v-if="!pending && !error">
                    <h3 class="text-5xl font-medium leading-13.5 tracking-[-0.03rem]" v-html="data.data.title"></h3>
                </div>
                <UButton color="transparent" variant="round" icon="i-lucide-x" @click="open = false" />
            </div>
        </template>
        <template #body>
            <div class="inner">
                <div v-if="!pending && !error">
                    <MessHtml v-if="data.data.copy" :html="data.data.copy" tag="div" class="copy markdown-content" />
                    <UAccordion :items="sections" class="help-accordion">
                        <template #content="{ item }">
                            <MessHtml v-if="item.content" :html="item.content" tag="div" class="copy markdown-content" />
                        </template>
                    </UAccordion>
                </div>
            </div>
        </template>
    </UDrawer>
</template>

<style>
.help-drawer .closebutton:hover {
    border-color: var(--teal);
}

.help-drawer .closebutton:hover circle {
    stroke: var(--teal);
    fill: var(--teal);
}

.help-drawer .closebutton:hover path {
    fill: var(--cream);
}

.help-drawer .inner .copy p,
.help-drawer .inner .copy iframe,
.help-drawer .inner .copy object,
.help-drawer .inner .copy ul,
.help-drawer .inner .copy ol {
    margin-bottom: 2.375rem;
}
</style>
